{
  "title": "Filtres de suivi d'activité",
  "tooltip": "Ces filtres excluent les FBO et utilisateurs des rapports d'activité et des indicateurs.",
  "unknown": "Inconnu",
  "testFBOs": {
    "sectionTitle": "FBO de test/démo",
    "addButton": "Ajouter FBO test",
    "columns": {
      "fboName": "Nom du FBO",
      "reason": "Motif",
      "actions": "Actions"
    },
    "deleteButton": "Supprimer",
    "dialog": {
      "title": "Ajouter FBO test/démo",
      "selectFboLabel": "Choisir FBO",
      "reasonLabel": "Motif (facultatif)",
      "reasonPlaceholder": "p. ex., Compte de test interne",
      "cancelButton": "Annuler",
      "addButton": "+"
    }
  },
  "employees": {
    "sectionTitle": "Employés AirPlx",
    "addButton": "Ajouter un employé",
    "autoExcludedChip": "*@airplx.com (auto-exclu)",
    "emptyState": "Aucun employé supplémentaire configuré (tous les e-mails @airplx.com sont automatiquement exclus)",
    "dialog": {
      "title": "Ajouter un employé AirPlx",
      "emailLabel": "Adresse e-mail",
      "emailPlaceholder": "user@example.com",
      "cancelButton": "Annuler",
      "addButton": "Ajouter"
    }
  }
}
